import { render, staticRenderFns } from "./ManageReportCategories.vue?vue&type=template&id=7b261135&scoped=true"
import script from "./ManageReportCategories.vue?vue&type=script&lang=js"
export * from "./ManageReportCategories.vue?vue&type=script&lang=js"
import style0 from "./ManageReportCategories.vue?vue&type=style&index=0&id=7b261135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b261135",
  null
  
)

export default component.exports